import { UseMutationResult, useMutation, useQueryClient } from 'react-query';
import httpClient from '../../core/httpClient';
import {
  YardiSyncProperty,
  YardiSyncPropertyRequest,
  YardiSyncRunRequest,
  YardiSyncRunResponse,
  YardiSyncSession,
  YardiSyncSessionRequest,
} from '../../types/yardiSync';

export const useUpdateYardiSyncSessionMutation = ():
UseMutationResult<YardiSyncSession, Error, YardiSyncSessionRequest> => {
  const queryClient = useQueryClient();
  return useMutation<YardiSyncSession, Error, YardiSyncSessionRequest>(
    async (request: YardiSyncSessionRequest) => {
      const response = await httpClient.post('/yardi-sync/session', request);
      return response.data;
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries('yardi-sync-session');
      },
    },
  );
};

export const useUpsertYardiSyncPropertyMutation = ():
UseMutationResult<YardiSyncProperty, Error, YardiSyncPropertyRequest> => {
  const queryClient = useQueryClient();
  return useMutation<YardiSyncProperty, Error, YardiSyncPropertyRequest>(
    async (request: YardiSyncPropertyRequest) => {
      const response = await httpClient.post('/yardi-sync/properties', request);
      return response.data;
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries('yardi-sync-properties');
      },
    },
  );
};

export const useTriggerYardiSyncRunMutation = ():
UseMutationResult<YardiSyncRunResponse, Error, YardiSyncRunRequest> => {
  const queryClient = useQueryClient();
  return useMutation<YardiSyncRunResponse, Error, YardiSyncRunRequest>(
    async (request: YardiSyncRunRequest) => {
      const response = await httpClient.post('/yardi-sync/run', request);
      return response.data;
    },
    {
      onSuccess: async () => {
        queryClient.invalidateQueries('yardi-sync-runs');
      },
    },
  );
};
